export default __webpack_public_path__ + "static/media/comprehensiveType.304847c1.svg";